import { t } from 'i18next'
import React from 'react'
import CustomImageComponent from '../../components/CustomImageComponent'

const PartnerSec = ({ data }) => {
    return (
        <section className='franchise-section'>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-12 col-lg-6 mb-4 mb-lg-0">
                        <CustomImageComponent className={"img-fluid"} src={data?.contentImage} alt="" />
                    </div>

                    <div className="col-md-12 col-lg-6">
                        <div dangerouslySetInnerHTML={{ __html: `${data?.content}` }} />

                        {/* <h5>
                            {t("franchise_content_1")}
                        </h5>
                        <p>
                            {t("franchise_content_2")}
                        </p>
                        <div className="flex-card">
                            <div className="content-block">
                                <h5>
                                    {t("franchise_content_3")}
                                </h5>
                                <p>
                                    {t("franchise_content_4")}
                                </p>
                            </div>
                        </div>
                        <div className="flex-card">
                            <div className="content-block">
                                <h5>
                                    {t("franchise_content_5")}
                                </h5>
                                <p>
                                    {t("franchise_content_6")}
                                </p>
                            </div>
                        </div>
                        <div className="flex-card">
                            <div className="content-block">
                                <h5>
                                    {t("franchise_content_7")}
                                </h5>
                                <p>
                                    {t("franchise_content_8")}
                                </p>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PartnerSec